var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPatientPhoneIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#004887"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.6667 33.74V37.24C39.668 37.5649 39.6014 37.8866 39.4713 38.1843C39.3411 38.482 39.1502 38.7492 38.9108 38.9689C38.6713 39.1885 38.3887 39.3558 38.0809 39.4599C37.7731 39.5639 37.4469 39.6026 37.1233 39.5734C33.5333 39.1833 30.0848 37.9565 27.055 35.9917C24.2361 34.2005 21.8462 31.8106 20.055 28.9917C18.0833 25.9481 16.8563 22.4829 16.4733 18.8767C16.4442 18.5541 16.4825 18.2289 16.5859 17.9219C16.6893 17.6149 16.8555 17.3328 17.0739 17.0936C17.2923 16.8543 17.5581 16.6632 17.8544 16.5323C18.1507 16.4014 18.4711 16.3337 18.795 16.3334H22.295C22.8612 16.3278 23.4101 16.5283 23.8394 16.8975C24.2687 17.2667 24.5491 17.7794 24.6283 18.34C24.7761 19.4601 25.05 20.5599 25.445 21.6184C25.602 22.0359 25.6359 22.4898 25.5429 22.9261C25.4498 23.3624 25.2337 23.7628 24.92 24.08L23.4383 25.5617C25.0992 28.4825 27.5175 30.9009 30.4383 32.5617L31.92 31.08C32.2372 30.7664 32.6377 30.5502 33.074 30.4571C33.5103 30.3641 33.9641 30.3981 34.3817 30.555C35.4402 30.95 36.5399 31.224 37.66 31.3717C38.2267 31.4516 38.7443 31.7371 39.1143 32.1738C39.4843 32.6104 39.6809 33.1679 39.6667 33.74Z",
    stroke: "#FCFCFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientPhoneIcon);
export default __webpack_public_path__ + "static/media/patient-phone-icon.c36c9c7a07c66f9532d1063f713fadf1.svg";
export { ForwardRef as ReactComponent };